/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './more-menu.css';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { MORE_MENU_SCREEN, COMMON, ADD_KRISHAK_SCREEN, ALL_ROUTES, ENVIRONMENT } from '../../global/Constants';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import AddImages from '../common/AddImages';
import { MORE_MENU_TYPES } from '../../global/Enum';
import { toast } from 'react-toastify';

import $ from 'jquery';


class SendFeedbackPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedTopic: null,
            allTopicsData: [],
            image: [],
            imagePaths: [],
            fields: {
                comments: ""
            },
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {

            const data = this.props.location.state;
            if (data?.activeTab === MORE_MENU_TYPES.SEND_FEEDBACK) {
                this.getAllUserFeedbackTopic();

                document.getElementById("send").disabled = true;
                Utilities.LogPrint("$$selectedData1299", this.props.location.state.selectedData);
                let selectedData = this.props.location.state.selectedData;
                if (selectedData) {
                    document.getElementById("send").style.visibility = "hidden";
                    this.setState({
                        fields: {
                            comments: selectedData.remarks
                        },
                        selectedTopic: {
                            value: selectedData.complain_type_id,
                            label: selectedData.complain_type
                        },
                        imagePaths: selectedData.images
                    })
                }
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        const value = e.target.value.replaceAll(/[^a-zA-Z0-9 ]/g, "");
        if (value) {
            fields[field] = value;
        } else {
            fields[field] = '';
        }
        this.setState({ fields });
        this.updateSendButton();
    };

    addUserFeedback = () => {
        this.props.loaderCallback(true);
        const { selectedTopic, images } = this.state;
        const comments = this._getFieldValue("comments", "");
        const formData = new FormData();
        formData.append("comment", comments);
        formData.append("is_active", true);
        formData.append("user_feedback_topic_id", selectedTopic.value);

        if (images != undefined) {
            for (var i = 0; i < images.length; i++) {
                formData.append("user_feedback_image", images[i]?.file);
            }
        }
        try {
            ApiServices.addUserFeedback(formData)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.props.loaderCallback(false);
                    if (response.success) {
                        toast.success(response.message);
                        this.props._sendToParent(false);

                        if (response.data > 0) {
                            this.postImage(images, response.data);
                        }
                    } else {
                        toast.error(response.message);
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                });
        } catch (error) {
            this.props.loaderCallback(false);
        }
    }

    postImage = (images, id) => {

        const formData = new FormData();
        let attachment = {
            attachment: {
                request: { id: id }
            }
        }

        if (images != undefined) {
            for (var i = 0; i < images.length; i++) {
                formData.append("file" + [i], images[i]?.file);
            }
        }
        formData.append("input_data", JSON.stringify(attachment));

        var settings = {
            "url": ENVIRONMENT.HELP_DESK_API,
            "method": "POST",
            "timeout": 0,
            "headers": {
                "Cookie": "SDPSESSIONID=811B08E438ABC2FD4099778DCBF5D837; sdpcsrfcookie=a0fae579-a583-49be-bfa7-88ba7bb17b30"
            },
            "processData": false,
            "mimeType": "multipart/form-data",
            "contentType": false,
            "data": formData
        };

        $.ajax(settings).done(function (response) {

        });
    }

    updateSendButton = () => {
        const comments = this._getFieldValue("comments", "");
        const { selectedTopic } = this.state;
        document.getElementById("send").disabled = !(comments !== "" && selectedTopic);
    }

    handleSendClick = () => {
        this.props._sendToParent(true);
        this.addUserFeedback();
    }

    handleTopicChange = selectedTopic => {
        this.setState({ selectedTopic }, () => {
            this.updateSendButton();
        });
    };

    getAllUserFeedbackTopic = () => {
        if (Utilities.isNetworkConnected()) {
            this.props.loaderCallback(true);
            var body = JSON.stringify({
                page: 1,
                perPage: 10,
                searchKey: "",
                sortBy: "created_at",
                sortOrder: "ASC",
                lastSync: "2021-01-01 00:00:00"
            });
            try {
                ApiServices.getAllUserFeedbackTopic(body).then(response => {
                    var status = response.success;
                    if (status) {
                        const newArrayOfObj = response.data.data.map(({ user_feedback_topic_id: value, title: label, ...rest }) => ({ value, label, ...rest }));
                        this.setState({ allTopicsData: newArrayOfObj });
                        this.props.loaderCallback(false);
                        Utilities.LogPrint("getAllUserFeedbackTopic", this.state.allTopicsData);
                    } else {
                        this.props.loaderCallback(false);
                        Utilities.LogPrint("getAllUserFeedbackTopic", response);
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("getAllUserFeedbackTopic", error);
                });
            } catch (error) {
                this.props.loaderCallback(false);
                Utilities.LogPrint("getAllUserFeedbackTopic", error);
            }
        }
    }

    handleAddImages = (e, images, selectedFiles) => {
        this.setState({
            images: selectedFiles,
            imagePaths: images
        })
        Utilities.LogPrint("Images", selectedFiles);
    }

    render() {
        const { isActive } = this.props;
        const { imagePaths } = this.state;
        const { allTopicsData, selectedTopic } = this.state;
        let comments = this._getFieldValue("comments", "");
        return (
            <div id="sendFeedback" className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <div className="row">
                    <div className="col-12">
                        <h6 className="mb-3">{MORE_MENU_SCREEN.SEND_FEEDBACK}</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label className="font-weight-medium">{COMMON.COMPLAIN_TYPE}</label>
                            <Select className="mb-3 max-w-360"
                                value={selectedTopic}
                                onChange={this.handleTopicChange}
                                options={allTopicsData}
                                placeholder={ADD_KRISHAK_SCREEN.SELECT_ANY_ONE}
                                isClearable={true}
                            />
                        </div>

                        <div className="form-group">
                            <label className="font-weight-medium">
                                {MORE_MENU_SCREEN.COMMENTS_SUGGESTIONS}
                            </label>
                            <textarea className="form-control" rows="5" onChange={this._handleValueChange.bind(this, "comments")} value={comments}></textarea>
                        </div>

                        <AddImages
                            fromFeedBack={true}
                            imagePaths={imagePaths}
                            handleAddImages={this.handleAddImages}
                            deleteActivityImageApi={this.deleteGroupMeetingImageApi} />

                        <div className="row">
                            <div className="col-12 d-flex button-grp-bottom">
                                <button className="btn btn-secondary w-50 mr-2" onClick={() => { this.props._sendToParent(false) }}>{COMMON.CANCEL}</button>
                                <button id="send" className="btn btn-primary w-50" onClick={this.handleSendClick}>{COMMON.SEND}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(SendFeedbackPage)